// extracted by mini-css-extract-plugin
export default {"navigation_container":"Navigation_navigation_container__-BEde","nav_link":"Navigation_nav_link__+9D28","drawer_opt":"Navigation_drawer_opt__THArq"};